const updates = [
  { date: '07-30', title: '《速度与激情10》超清版上线', tag: '新片', tagClass: 'bg-primary-100 text-primary-700' },
  { date: '07-29', title: '《长相思》第二季更新至第28集', tag: '热播', tagClass: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '新增悬疑推理分类专题页面', tag: '更新', tagClass: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '《蜘蛛侠：纵横宇宙》高清资源已上线', tag: '新片', tagClass: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '韩剧《现在拨打的电话》全集更新完毕', tag: '完结', tagClass: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '服务器全面升级，播放加载速度提升40%', tag: '优化', tagClass: 'bg-secondary-100 text-secondary-700' },
  { date: '07-24', title: '《灌篮高手》大电影国日双语版上线', tag: '新片', tagClass: 'bg-primary-100 text-primary-700' },
  { date: '07-23', title: '纪录片《地球脉动III》全系列资源更新', tag: '纪录片', tagClass: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">嫩草视频资源更新与平台动态</p>
        </div>

        <div className="space-y-3">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 md:w-20 flex-shrink-0 text-center">
                <div className="font-label font-medium text-xs text-foreground-400">{item.date}</div>
                <div className="mt-1 w-2 h-2 rounded-full bg-primary-400 mx-auto"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-label text-sm text-foreground-800 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </p>
              </div>
              <span className={`px-2 py-0.5 rounded-full text-xs font-label flex-shrink-0 whitespace-nowrap ${item.tagClass}`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}